import { isUrl } from '@/domains/document/helpers/file-type'
import { output } from '@/helpers/std-out'
import { load, validate } from '@scalar/openapi-parser'

import as from 'ansis'
import fs from 'node:fs'

/**
 * Pass a file path or URL and get the content of the file.
 */
export const getFileOrUrl = async (input: string): Promise<string> => {
  if (isUrl(input)) {
    const response = await fetch(input)

    if (!response.ok) {
      return output.error().title('Failed to fetch from URL.').exit('error')
    }

    return await response.text()
  }

  if (!fs.existsSync(input)) {
    return output.error().title('Could not read file.').exit('error')
  }

  return fs.readFileSync(input, 'utf-8')
}

export const loadOpenApiFile = async (input: string) => {
  const specification = await getFileOrUrl(input)

  try {
    const { filesystem } = await load(specification)
    const result = await validate(filesystem)

    // Invalid specification
    if (!result.valid) {
      output
        .warn()
        .title('File does not match the OpenAPI specification.')
        .print()

      // Output errors
      result.errors?.forEach((error: any) => {
        output.warn().title(`${error.error} (${error.path})`).print()
      })

      return result
    }

    return result
  } catch (error: unknown) {
    output
      .error()
      .title(error ? as.red(error.toString()) : 'Unknown error.')
      .print()

    const message =
      typeof error === 'object' && error !== null && 'message' in error
        ? error.message
        : 'Unknown error'

    return {
      valid: false,
      version: undefined,
      specification: undefined,
      schema: undefined,
      errors: [
        {
          error: message,
          path: '',
        },
      ],
    }
  }
}
